<template>
  <div class="inhalt">
    <div class="top">
      <div class="packshot">
        <img src="@/assets/images/inhalt/packshot.png" alt="Packshot" />
      </div>
      <div class="content">
        <div class="kinostart" v-html="kinostart"></div>
        <div class="kinostart2" v-html="kinostart2"></div>
        <div class="buttons">
          <a
            href="https://www.amazon.de/N%C3%B6-Anna-Br%C3%BCggemann/dp/B09Q8WM1DM/ref=sr_1_2?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3BICSB7F0XID4&keywords=Dietrich+Br%C3%BCggemann&qid=1642500037&s=dvd&sprefix=dietrich+br%C3%BCggemann%2Cdvd%2C101&sr=1-2"
            target="_blank"
          >
            <img src="@/assets/images/inhalt/amazon.png" alt="Amazon" />
          </a>
          <a
            href="https://tv.apple.com/de/movie/no/umc.cmc.1apkv6r2wgbtv8jfezdc94rvj?itsct=tv_box_link&itscg=30200"
            target="_blank"
          >
            <img src="@/assets/images/inhalt/itunes.png" alt="Itunes" />
          </a>
        </div>
      </div>
    </div>
    <div class="bottom desktop-inhalt">
      <div class="left">
        Dina <span>(Anna Brüggemann)</span> und Michael
        <span>(Alexander Khuon)</span>, er Arzt, sie Schauspielerin, sind
        eigentlich glücklich in ihrer Beziehung, bis Michael beginnt, laut über
        eine Trennung nachzudenken. Die Frage „Könnten wir nicht glücklicher
        sein als in dieser Konstellation?“ steht im Raum. Aber Dina sagt: „Nö.“
        <span
          >In fünfzehn Situationen und über sieben Jahre hinweg begleiten wir
          das Paar, wie es sich durchs Leben laviert und dabei versucht, die
          Liebe nicht aus den Augen zu verlieren. Wie es versucht, den eigenen
          Eltern gerecht zu werden, im Beruf nicht unterzugehen und selbst gute
          Eltern zu sein.</span
        >
      </div>
      <div class="right">
        <img src="@/assets/images/inhalt/pic01.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['kinostart', 'kinostart2'],
}
</script>

<style lang="scss" scoped>
.inhalt {
  border-top: 10px solid white;
  background: transparent url('@/assets/images/inhalt/bg.jpg') top center
    no-repeat;
  background-size: cover;
  .top {
    height: 220px;
    padding-block: 1em;
    display: flex;
    width: 768px;
    margin-inline: auto;
    .packshot {
      z-index: 10;
      margin-top: -50px;
      text-align: right;
      img {
        width: 80%;
      }
    }
    .content {
      flex: 1;
      .buttons {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        a {
          display: block;
          margin-inline: 10px;
        }
      }
    }
    .kinostart {
      font-size: 46px;
      line-height: 1;
      font-weight: 900;
      color: white;
      text-transform: uppercase;
      text-align: center;
    }
    .kinostart2 {
      font-size: 28px;
      line-height: 1;
      color: white;
      text-transform: uppercase;
      text-align: center;
    }
  }
  .bottom {
    max-width: 1362px;
    display: flex;
    color: white;
    font-size: 1.5rem;
    margin-inline: auto;
    padding-block: 1em;
    span {
      font-weight: 700;
    }
    .left {
      padding-top: 20px;
    }
    @media (max-width: 1400px) {
      flex-direction: column;
      align-items: center;
      padding-inline: 2em;
      .left {
        margin-bottom: 1em;
      }
    }
  }
}
</style>
